// extracted by mini-css-extract-plugin
module.exports = {"pill":"TagPill_pill__1SZ47","selected":"TagPill_selected__9eBms"};